module.exports = __webpack_public_path__ + "img/EmojiTransportationOutlined.ca9bdcff.svg";